module.exports = __webpack_public_path__ + "img/Recurso 25@300x.d1365748.png";